import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { CiLocationOn, CiNoWaitingSign } from 'react-icons/ci';
import { useTranslation } from 'react-i18next';
import { FaStar } from 'react-icons/fa';
import LocationButton from '../ui/LocationButton';
import { FaBed, FaCalendarAlt } from 'react-icons/fa';
import { FaWallet, FaMoneyBillWave, FaCreditCard } from 'react-icons/fa';
import dayjs from 'dayjs';
import Cookies from 'js-cookie';
import { MdOutlineNumbers } from 'react-icons/md';
import { BiErrorCircle } from "react-icons/bi";
import { addBookHall, addBookStay, addPayment, clearBooking } from '../../features/home/bookingSlice';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { fetchPlaceReviews } from '../../features/admin/placeSlice';
import { useSEO } from '../../custom hooks/useSEO';
import { Room } from '../../types';
const PAYMENT_METHODS = [
	{ id: 0, key: 'Wallet', label: 'myWallet', icon: FaWallet, color: 'text-secondry' },
	{ id: 1, key: 'Cash', label: 'cashPayment', icon: FaMoneyBillWave, color: 'text-green-600' },
	{ id: 2, key: 'Online', label: 'onlinePayment', icon: FaCreditCard, color: 'text-blue-600' },
];

const CheckOut = () => {
	const { t, i18n } = useTranslation();
	const { t: tSeo } = useTranslation("seo");

	const seo = useSEO({
		title: tSeo("placeCheckout.title"),
		description: tSeo("placeCheckout.description")
	});
	const dispatch = useDispatch<AppDispatch>();
	const [showSuccessPage, setShowSuccessPage] = useState<boolean>(false)
	const [showFailedPage, setShowFailedPage] = useState<boolean>(false)
	const [showWaitingPage, setShowWaitingPage] = useState<boolean>(false)
	const [showPhoneVerificationRequired, setShowPhoneVerificationRequired] = useState(false);
	const [selectedMethod, setSelectedMethod] = useState('Wallet');
	const { place, reviews } = useSelector((state: RootState) => state.placeSlice);
	const { checkIn, checkOut, roomIds, selectedOptionalService, duration, loading, selectedRooms } = useSelector((state: RootState) => state.bookingSlice);
	const { Room } = useSelector((state: RootState) => state.roomSlice);
	const { user } = useSelector((state: RootState) => state.user);
	const userId = Cookies.get('userId');
	useEffect(() => {
		if (place?.id) dispatch(fetchPlaceReviews(place?.id))
		console.log(selectedRooms)
		console.log(selectedRooms)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch])

	const middleRef = useRef<HTMLDivElement | null>(null);
	useEffect(() => {
		middleRef.current?.scrollIntoView({ behavior: "smooth" });
	}, []);

	const visiblePaymentMethods = React.useMemo(() => {
		if (!place?.paymentMethod || place?.paymentMethod.length === 0) {
			return PAYMENT_METHODS;
		}

		return PAYMENT_METHODS.filter(
			(method) =>
				method.id === 0 || place?.paymentMethod.includes(method.id)
		);
	}, [place?.paymentMethod]);


	const totalOptionalPrice = selectedOptionalService.reduce(
		(sum, service) => sum + Number(service.price || 0),
		0
	);
	const nights = dayjs(checkOut).diff(dayjs(checkIn), 'day');
	const isHall = place?.type.toLowerCase() === "hall";
	const isHotel = place?.subCategory.id === 1;
	let bookingPrice: number = 0;
	if (isHotel) {
		bookingPrice = selectedRooms?.reduce((sum: number, room: Room) => {
			const price = room.hasOffer
				? room.pricePerNight * (1 - room.discount / 100)
				: room.pricePerNight;
			return sum + price;
		}, 0) * nights;


	}
	else if (isHall) {
		bookingPrice =
			(Number(duration) === 1 ?
				place?.discountPercentage > 0 ?
					((place?.price * (1 - place?.discountPercentage / 100)) || 0) : (place?.price || 0)
				:
				place?.discountNightPercentage && place?.discountNightPercentage > 0 ?
					(place?.priceNight || place?.price) && (((place?.priceNight || place?.price) * (1 - place?.discountNightPercentage / 100)) || 0) : (place?.priceNight || place?.price)) || 0
	}
	else {
		if (place) bookingPrice = place?.discountPercentage > 0 ? ((place?.price * (1 - place?.discountPercentage / 100)) || 0) * nights : (place?.price || 0) * nights;
	}
	const totalPrice = bookingPrice + totalOptionalPrice;
	const handlePayment = async () => {
		if (user?.phone === "+99900000000") {
			setShowPhoneVerificationRequired(true);
			return;
		} else {
			if (selectedMethod === 'Online' && userId) {
				if (!user?.phone.startsWith("+218")) {
					toast.error(t("online-payment-not-availabe"))
					return
				}
				try {
					const BookRes = await dispatch(
						place?.type === "Hall" ?
							addBookHall({
								userId,
								placeId: place?.id,
								bookDate: dayjs(checkIn).add(dayjs().utcOffset(), 'minute').toISOString(),
								duration: Number(duration),
								optionalServices: selectedOptionalService.map(service => service.id),
								paymentMethod: 'Online',
							}) :
							addBookStay({
								userId,
								rooms: place?.subCategory.id === 1 ? roomIds : undefined,
								placeId: place?.id,
								checkIn: dayjs(checkIn).add(dayjs().utcOffset(), 'minute').toISOString(),
								checkOut: dayjs(checkOut).add(dayjs().utcOffset(), 'minute').toISOString(),
								optionalServices: selectedOptionalService.map(service => service.id),
								paymentMethod: 'Online'
							})
					).unwrap();
					if (BookRes?.success) {
						dispatch(clearBooking())
						if (place?.placeIDInPOS) {
							const type = place.type === "Hall" ? "Hall" : "Stay"
							const res = await dispatch(addPayment({ userId, bookId: BookRes.data, type })).unwrap();

							if (res?.data.url) {
								window.location.href = res.data.url;
							}
						} else {
							setShowWaitingPage(true);
						}
					} else {
						setShowFailedPage(true);
					}

				} catch (err) {
					console.error('Online payment error:', err);
				}
			}
			else if (selectedMethod === 'Cash') {
				try {
					const res = await dispatch(
						place?.type === "Hall" ?
							addBookHall({
								userId,
								placeId: place?.id,
								bookDate: dayjs(checkIn).add(dayjs().utcOffset(), 'minute').toISOString(),
								duration: Number(duration),
								optionalServices: selectedOptionalService.map(service => service.id),
								paymentMethod: 'Cash',
							}) :
							addBookStay({
								userId,
								rooms: place?.subCategory.id === 1 ? roomIds : undefined,
								placeId: place?.id,
								checkIn: dayjs(checkIn).add(dayjs().utcOffset(), 'minute').toISOString(),
								checkOut: dayjs(checkOut).add(dayjs().utcOffset(), 'minute').toISOString(),
								optionalServices: selectedOptionalService.map(service => service.id),
								paymentMethod: 'Cash',
							})
					).unwrap();
					if (res?.success) {
						dispatch(clearBooking())
						if (place?.placeIDInPOS) {
							setShowSuccessPage(true);
						}
						else {
							setShowWaitingPage(true);
						}
					} else {
						setShowFailedPage(true);
					}
				} catch (err) {
					console.error("Cash booking error:", err);
					setShowFailedPage(true);
				}
			}
			else if (selectedMethod === 'Wallet') {
				toast.error('Wallet payment coming soon...');
			}
		}
	};
	return (
		<div className=' bg-white padding-container main-prop' ref={middleRef}>
			{seo}
			<div className='flex xs:flex-col md:flex-row  gap-8 '>
				<div className='flex-1 rounded-lg border p-5 '>
					<h1 className='text-2xl font-semibold mb-4'>{t("your-stay")}</h1>
					<div className='flex w-full  overflow-hidden rounded-2xl border  shadow-sm"'>
						<div className=" sm:w-48 xs:w-32  overflow-hidden  relative">
							<img
								src={place?.images[0]?.url}
								alt={place?.title}
								className=" w-full h-full object-cover"
							/>
							<span className={` absolute top-3 ${i18n.language === "ar" ? "right-3" : "left-3"}  rounded-md bg-primary px-3 py-1 text-sm text-white `}>
								{place?.subCategory?.title || place?.type}
							</span>
						</div>
						<div className="flex flex-col justify-between flex-1 p-3">
							<div className="flex items-start justify-between">
								<div className="flex items-center gap-2 text-sm text-gray-600 mt-2">
									<FaStar className="text-secondry" />
									{place?.rate.toFixed(1)} <span className="text-gray-400">({reviews.length} {t("reviews")})</span>
								</div>
							</div>
							{/* Title */}
							<h2 className="text-xl font-bold ">{place?.title}</h2>
							{/* Location */}
							<p className="text-sm text-gray-500 flex items-center gap-1">
								<CiLocationOn /> {place?.location}
							</p>
						</div>
					</div>
					<section className="mt-10  w-full">
						<h2 className="text-2xl font-semibold mb-4">{t("amenities")} </h2>
						<div className="grid grid-cols-2 sm:grid-cols-3 mb-4 gap-4">
							{place?.amenities.length === 0 && <div className=" text-textSecond">{t("no-services")}</div>}
							{place?.amenities.map((amenity) => (
								<div key={amenity.id} className="flex items-center gap-3  rounded-lg">
									<img src={amenity.image} alt={amenity.title} className="w-6 h-6" />
									<span className="text-sm text-nowrap texttextSecond">{amenity.title}</span>
								</div>
							))}
						</div>
					</section>
					<LocationButton link={`/place/${place?.id}/map-view`} />
				</div>
				<div className='flex-1 xs:p-0 md:p-5'>
					<div className="">
						<h2 className="text-2xl font-bold texttextSecond mb-4">{t('bookingDetails')}</h2>
						<div className="space-y-2 justify-between pb-4 mb-4">
							<div className="flex justify-between text-sm text-textSecond">
								<div className="flex gap-1 items-center">
									<FaCalendarAlt />
									<p>{t('checkIn')}</p>
								</div>
								<p >{dayjs(checkIn).format('DD/MM/YYYY')}</p>
							</div>

							{place?.type === "Hall" ?
								<div className="flex justify-between text-sm text-textSecond">

									<div className='flex gap-1 items-center'>
										<FaCalendarAlt />
										<p>{t('duration-label')}</p>

									</div>
									<p>{Number(duration) === 1 ? t("morning-period") : t("afternoon-period")}</p>
								</div>
								: <div className="flex justify-between text-sm text-textSecond">

									<div className='flex gap-1 items-center'>
										<FaCalendarAlt />
										<p>{t('checkOut')}</p>

									</div>
									<p>{dayjs(checkOut).format('DD/MM/YYYY')}</p>
								</div>
							}

							{isHotel && <>
								<div className="flex justify-between text-sm text-textSecond">
									<div className="flex flex-1 items-center gap-1  font-medium">
										<FaBed />
										<p>{t('room-type')}</p>
									</div>
									<p >
										{selectedRooms.map(room => room.type).join("، ")}
									</p>
								</div>
								<div className="flex justify-between text-sm text-textSecond">
									<div className="flex items-center gap-1  font-medium">
										<MdOutlineNumbers />
										<p>{t('room-number')}</p>
									</div>
									{selectedRooms.map(room => room.roomNumber).join("، ")}
								</div>
							</>
							}
						</div>

					</div>
					<div >
						{/* Payment Details */}
						<div className="mb-6">
							<h2 className="text-lg font-semibold text-secondry mb-2">{t('paymentDetails')}</h2>
							<div className="flex text-textSecond text-sm items-center justify-between ">
								<div >{t('booking-price')}</div>
								<div >{bookingPrice?.toFixed(2)} {Room?.currencyCode}</div>
							</div>
							<div className="flex  mb-2 text-textSecond text-sm items-center justify-between ">
								<div >{t('additional-service')}</div>
								<div >{totalOptionalPrice.toFixed(2)} {Room?.currencyCode}</div>
							</div>
							<div className="flex items-center justify-between ">
								<div >{t('totalAmount')}</div>
								<div className="text-orange-600 font-bold">{totalPrice?.toFixed(2)} {Room?.currencyCode}</div>
							</div>
						</div>
						{/* Payment Method */}
						<div>
							<h2 className="text-lg font-semibold text-orange-600 mb-2">
								{t('paymentMethod')}
							</h2>

							<div className="grid xs:grid-cols-1 sm:grid-cols-2 grid-cols-3 gap-4">
								{visiblePaymentMethods.map(({ id, key, label, icon: Icon, color }) => (
									<label
										key={id}
										className={`flex items-center w-full gap-2 p-2 border rounded-lg cursor-pointer
          										${selectedMethod === key
												? 'border-secondry bg-orange-50'
												: 'border-gray-200'}`}
									>
										<input
											type="radio"
											name="paymentMethod"
											className="accent-secondry focus:outline-none"
											checked={selectedMethod === key}
											onChange={() => setSelectedMethod(key)}
										/>

										<Icon className={`text-2xl ${color}`} />
										<div className=' flex flex-col'>
											<div className="font-medium">{t(label)}</div>
											{id === 0 &&
												<div className="text-xs text-nowrap text-textSecond">
													{t('available')} = <span className="text-secondry">0.00 LYD</span>
												</div>
											}
										</div>

									</label>
								))}
							</div>

							<div className="mt-6">
								<button
									onClick={handlePayment}
									disabled={loading}
									className={`bg-primary text-white px-6 w-full py-3 rounded-lg transition
        ${loading ? 'opacity-60 cursor-not-allowed' : 'hover:scale-105'}`}
								>
									{loading ? (
										<div className="flex items-center justify-center gap-2">
											<span className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent" />
											<span>{t('processing')}</span>
										</div>
									) : (
										t('confirmPayment')
									)}
								</button>
							</div>
						</div>

					</div>
				</div>
			</div>
			{showSuccessPage &&
				<div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-5 z-50">
					<div className="bg-white p-6 rounded-xl w-full max-w-sm shadow-lg space-y-4">
						<div className=' flex gap-10 flex-col items-center justify-between w-full '>
							<div className=' text-center'>
								<h2 className='text-xl font-semibold mb-2'>{t("successfully")}</h2>
								<p className=' mb-2'>{t("booked-success")}</p>
								<div className=' w-24'>
									<img src="/asset/success.png" className=' w-full' alt="success" loading='lazy' />
								</div>
							</div>
							<Link className=' text-white bg-primary rounded-lg py-2 text-center w-full' to={`${isHall ? "/me/halls-bookings" : "/me/stay-bookings"}`}>{t("continue")}</Link>
						</div>
					</div>
				</div>}
			{showFailedPage &&
				<div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-5 z-50">
					<div className="bg-white p-6 rounded-xl w-full max-w-sm shadow-lg space-y-4">
						<div className=' flex gap-10 flex-col items-center justify-between w-full '>
							<div className=' flex-center flex-col text-center'>
								<h2 className='text-xl font-semibold mb-2'>{t("failed")}</h2>
								<p className=' mb-2'>{t("booked-failed")}</p>
								<div className=' w-16 h-16 border-[#dc26264d] rounded-full border-4 flex-center text-red-600 text-8xl'>
									<BiErrorCircle />
								</div>
							</div>
							<button
								onClick={() => setShowFailedPage(false)}
								className=' text-white bg-red-600 rounded-lg py-2 text-center w-full'>
								{t("accept")}
							</button>
						</div>
					</div>
				</div>}
			{showWaitingPage &&
				<div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-5 z-50">
					<div className="bg-white p-6 rounded-xl w-full max-w-sm shadow-lg space-y-4">
						<div className=' flex gap-10 flex-col items-center justify-between w-full '>
							<div className=' flex-center flex-col text-center'>
								<h2 className='text-xl font-semibold mb-2'>{t("wait")}</h2>
								<p className=' mb-2'>{t("booked-waiting")}</p>
								<div className=' w-16 h-16 border-[#da6d004f] rounded-full border-4 flex-center text-secondry text-8xl'>
									<CiNoWaitingSign />
								</div>
							</div>
							<Link
								to={`${isHall ? "/me/halls-bookings" : "/me/stay-bookings"}`}
								className=' text-white bg-secondry rounded-lg py-2 text-center w-full'>
								{t("accept")}
							</Link>
						</div>
					</div>
				</div>}
			{showPhoneVerificationRequired &&
				<div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-5 z-50">
					<div className="bg-white p-6 rounded-xl w-full max-w-sm shadow-lg space-y-4">
						<div className="flex gap-10 flex-col items-center justify-between w-full">
							<div className="flex-center flex-col text-center">
								<h2 className="text-xl font-semibold mb-2">{t("phone-number-required")}</h2>
								<p className="mb-2 text-gray-600">{t("please-verify-phone")}</p>
								<div className="w-20 h-20 border-[#facc153d] rounded-full border-4 flex-center text-yellow-500 text-6xl">
									<MdOutlineNumbers />
								</div>
							</div>
							<div className=' w-full flex flex-col gap-3'>
								<Link
									to="/me/settings"
									className="text-white bg-yellow-500 rounded-lg py-2 text-center w-full hover:bg-yellow-600 transition">
									{t("verify-now")}
								</Link>
								<button
									onClick={() => setShowPhoneVerificationRequired(false)}
									className="text-gray-600 border border-gray-300 rounded-lg py-2 text-center w-full hover:bg-gray-100 transition">
									{t("later")}
								</button>
							</div>

						</div>
					</div>
				</div>
			}
		</div>
	)
}

export default CheckOut


